import { cn } from '@/components/ui/utils';
import seedrandom from 'seedrandom';

import { cva, VariantProps } from 'class-variance-authority';

const styles = cva('w-10 h-10 flex-shrink-0 flex items-center justify-center overflow-hidden', {
  variants: {
    shape: {
      circle: 'rounded-full',
      rectangle: 'rounded',
    },
  },
  defaultVariants: {
    shape: 'circle',
  },
});

const randomBackgrounds: string[] = [
  'from-slate-400 to-gray-700',
  'from-red-400 to-rose-700',
  'from-orange-400 to-red-700',
  'from-amber-400 to-orange-700',
  'from-yellow-400 to-amber-700',
  'from-lime-400 to-yellow-700',
  'from-green-400 to-lime-700',
  'from-emerald-400 to-green-700',
  'from-teal-400 to-emerald-700',
  'from-cyan-400 to-teal-700',
  'from-sky-400 to-cyan-700',
  'from-blue-400 to-sky-700',
  'from-indigo-400 to-blue-700',
  'from-violet-400 to-indigo-700',
  'from-purple-400 to-violet-700',
  'from-fuchsia-400 to-purple-700',
  'from-pink-400 to-fuchsia-700',
  'from-rose-400 to-red-700',
];

export type TappAvatarProps = {
  src?: string | null;
  name?: string | null;
} & VariantProps<typeof styles> &
  React.ComponentProps<"div">;

export const TappAvatar: React.FC<TappAvatarProps> = ({ className, src, name, shape, ...props }) => {
  const getRandomBg = () => {
    const rng = seedrandom(name || Math.random().toString());
    return randomBackgrounds.at(Math.floor(rng.quick() * randomBackgrounds.length))!;
  };

  return (
    <div className={cn(styles({ shape }), className)}>
      {src && (
        <img
          className="h-full w-full object-cover object-center"
          src={src}
          alt={name ?? ''}
          referrerPolicy="no-referrer"
        />
      )}
      {!src && name && (
        <p
          className={cn(
            'flex h-full w-full items-center justify-center bg-gradient-to-br text-base font-semibold uppercase text-white/90',
            getRandomBg()
          )}
        >
          {(name || '').split(' ').length > 1
            ? (name || '')
                .split(' ')
                .slice(0, 2)
                .map((n) => n.charAt(0))
                .join('')
            : (name || '').slice(0, 2)}
        </p>
      )}
    </div>
  );
};
